<template>
  <div class="programCrudComp">
    <div>
      <label class="label_title" for="">ID</label>
      <input-comp :classInput="'input_grey'" :value="data.id.value" v-model="data.id.value" disabled/>
      <p class="p_err_min"></p>
    </div>
    <div>
      <label class="label_title" for="">Время массажа, мин.</label>
      <input
          :disabled="role != 'dealer'"
          type="number"
          min="0"
          max="31"
          v-model="data.countMinutes.value"
          :class="[{'animated shake error_input': errors.countMinutes}, 'input_grey']"
          @click="resetError('countMinutes')"
      >
      <p class="p_err_min">{{ errors.countMinutes }}</p>
    </div>
    <!-- <div>
      <label class="label_title" for="">Стоимость, руб.</label>
      <input
        disabled
        type="number"
        v-model="price"
        :class="['input_grey']"
      >
      <p class="p_err_min">{{errors.price}}</p>
    </div> -->
    <div class="div_btns">
      <button-comp :disabled="role != 'dealer'" :classBtn="'btn_orange_min'" :textBtn="'Сохранить'" :clickBtn="save"/>
      <button-comp :classBtn="'btn_orange_min'" v-if="id" :textBtn="'Удалить'" :clickBtn="remove"/>
    </div>
    <p class="p_err_main">{{ errMain }}</p>
  </div>
</template>

<script>
export default {
  name: 'programCrudComp',
  props: {},
  data: function () {
    return {
      required: null,
      moduleName: 'programs',
      config: {
        moduleName: 'config'
      }
    }
  },
  beforeCreate () {
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getOne`, { required: this.required })
  },
  components: {},
  computed: {
    id: function () {
      return this.$store.getters[`${this.moduleName}/getId`]
    },
    data: function () {
      return this.$store.getters[`${this.moduleName}/getOne`]
    },
    errMain: function () {
      return this.$store.getters[`${this.moduleName}/getErrMain`]
    },
    errors: function () {
      return this.$store.getters[`${this.moduleName}/getErrors`]
    },
    role: function () {
      return localStorage.getItem('role')
    }
    // price: function() { return this.$store.getters[`${this.config.moduleName}/getOne`].program.stepPrice * this.$store.getters[`${this.moduleName}/getOne`].countMinutes.value }
  },
  methods: {
    save () {
      // this.data.price.value = this.price;
      this.$store.dispatch(`${this.moduleName}/createOrUpdate`, { data: this.data, required: this.required })
    },
    remove () {
      this.$store.dispatch(`${this.moduleName}/delete`)
    },
    toAll () {
      this.$store.dispatch(`${this.moduleName}/toAll`)
    },
    resetError (param) {
      this.$store.commit(`${this.moduleName}/setErrors`, { param: param, value: null })
    }
  }
}
</script>

<style scoped lang="scss">

.programCrudComp {
  width: 350px;
  margin: 32px auto 32px auto;
}

.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
}

@media screen and (max-width: 1140px) {
}

@media screen and (max-width: 960px) {
}

@media screen and (max-width: 720px) {
}

@media screen and (max-width: 540px) {
}

@media screen and (max-width: 480px) {
  .programCrudComp {
    width: calc(100% - 32px);
  }
}

@media screen and (max-width: 320px) {
}

</style>
